<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'app',
    data() {
      return {}
    },
    watch: {},
    created() {
    },
    methods: {},
    computed: {}
  }
</script>
<style lang="scss">
#app {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.el-menu--vertical{
  background-color: #f7f7f7 !important;
  .el-menu-item:focus, .el-menu-item:hover {
    background-color: #d1d1d1 !important;
  }
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  right: 8px !important;
}
.el-table{
  tr{
    td{
      .cell{
        span{
          word-break: break-word;
        }
      }
    }
  }
}
.td-cell-bg{
  span{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    >em{
      position: absolute;
      top: 50%;
      left: 0;
      text-align: center;
      width: 100%;
      transform: translate(0, -50%);
      font-style: normal;
    }
  }
}
.avue-left{
  .el-scrollbar__bar.is-horizontal{
    display: none;
  }
}
</style>
